import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { HeroSection } from '../components/home/HeroSection';
import { JobSearchPanel } from '../components/home/JobSearchPanel';
import { IntroSection } from '../components/home/IntroSection';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { ExecutiveFeature } from '../components/home/ExecutiveFeature';
import { FeaturedJobs } from '../components/home/FeaturedJobs';
import { IndustryDirectory } from '../components/home/IndustryDirectory';
import { ProcessPreview } from '../components/home/ProcessPreview';
import { WhyCorventa } from '../components/home/WhyCorventa';
import { AudienceSplit } from '../components/home/AudienceSplit';
import { StatsBand } from '../components/home/StatsBand';
import { InsightsPreview } from '../components/home/InsightsPreview';
import { TeamPreview } from '../components/home/TeamPreview';
import { Testimonials } from '../components/home/Testimonials';
import { NewsletterSection } from '../components/home/NewsletterSection';
import { FaqPreview } from '../components/home/FaqPreview';
import { CtaBand } from '../components/ui/CtaBand';
export function Home() {
  usePageMeta('', 'Corventa Talent Search connects organisations with exceptional professionals and leadership talent through research-led executive search and recruitment.');
  return <>
      <HeroSection data-id="element-942" data-mp="2hy71wzhgjc76" />
      <JobSearchPanel data-id="element-943" data-mp="2hyp7wntx94sa" />
      <IntroSection data-id="element-944" data-mp="2hz8ex9i1a8rj" />
      <ServicesOverview data-id="element-945" data-mp="2d775rwg5wy5q" />
      <ExecutiveFeature data-id="element-946" data-mp="2d6p0697m17l5" />
      <FeaturedJobs data-id="element-947" data-mp="2d6fakmqh92fz" />
      <IndustryDirectory data-id="element-948" data-mp="2d5w2ryujjufo" />
      <ProcessPreview data-id="element-949" data-mp="28840caw9spx8" />
      <WhyCorventa data-id="element-950" data-mp="287cevswe08ko" />
      <AudienceSplit data-id="element-951" data-mp="288vv5ji1mjmg" />
      <StatsBand data-id="element-952" data-mp="288dpxxdekv2e" />
      <InsightsPreview data-id="element-953" data-mp="285rhlvioubj4" />
      <TeamPreview data-id="element-954" data-mp="239j9h22wrilg" />
      <Testimonials data-id="element-955" data-mp="23a2fbkfaagj4" />
      <NewsletterSection data-id="element-956" data-mp="23am15c821p2f" />
      <FaqPreview data-id="element-957" data-mp="2376jq2qws3xu" />
      <CtaBand data-id="element-958" data-mp="1z764ifvzjopq" />
    </>;
}